import React, { useState } from 'react';
import DatePicker from 'react-datepicker'; // Import a date picker library
import {ReactComponent as DropdownIcon} from '../components/svgs/dropdownIcon.svg';


const DropdownDatePicker = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
  
    const handleInputClick = () => {
      setIsOpen(!isOpen);
    };
  
    const handleDateChange = (date) => {
      setSelectedDate(date);
      setIsOpen(false);
    };
  
    return (
      <div className="dropdown-datepicker">
        <label htmlFor=""> Pickup Date
            <input
            type="text"
            placeholder="DD - MM - YYYY"
            value={selectedDate ? selectedDate.toDateString() : ''}
            onClick={handleInputClick}
            readOnly
            style={{ width: '305px' }} // Adjust width of input field
            className='mt-2'
            />
            <DropdownIcon className="dropdown-icon mt-4" onClick={handleInputClick} />
            {isOpen && (
            <div className="datepicker-container">
                <DatePicker
                selected={selectedDate}
                onChange={handleDateChange}
                inline
                //   showTimeSelect
                />
                
            </div>
            )}
        </label>
      </div>
    );
};

export default DropdownDatePicker;
